import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './index.module.scss'
import scrollLock from '../../../../../utils/scroll-lock'

interface IProps {
  order: any
  onClose: () => void
}

export default function LookAroundTip({ order, onClose }: IProps) {
  const history = useHistory()

  useEffect(() => {
    scrollLock.enable()
    return () => {
      scrollLock.disable()
    }
  }, [])

  const linkToLookAround = () => {
    history.push(`/ms/around/${order.id}`)
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <div
      className={styles.drawerWrap}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <div className={styles.drawerContainer}>
        <div className={styles.closeBtn} onClick={handleClose}></div>
        <p className={styles.title}>请确认客户及车辆信息</p>
        <div className={styles.userInfoWrap}>
          <div className={styles.vehicleInfo}>
            <p className={!order.plateNo ? styles.flex1 : ''}>{order.id}</p>
            <p>{order.plateNo || order.vin}</p>
            <p className={styles.vehicleDetail}>
              <span>{order.vehicleSeries}</span>
              <span>{order.vehicleModel}</span>
              <span>{order.vehicleVersion}</span>
            </p>
          </div>
          <div className={styles.customInfo}>
            <div className={styles.nameStatus}>
              <p className={styles.name}>{order.reserveName}</p>
              <p className={styles.mobile}>{order.reserveMobile}</p>
            </div>
            <div className={styles.address}>
              <div className={styles.iconAddress}></div>
              <p className={styles.addressDetail}>{order.reserveAddress}</p>
            </div>
          </div>
        </div>
        <div className={styles.lookAroundBtn} onClick={linkToLookAround}>进行环车检查</div>
      </div>
    </div>
  )
}
